import React from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import FallbackUI from './FallbackUI';
import { logger } from '../logger/Logger';

const ErrorBoundary = ({ children }) => {
    const handleError = (error, info) => {
        logger.error("Uncaught Error:", { error, info });
    };

    return (
        <ReactErrorBoundary
            FallbackComponent={FallbackUI}
            onError={handleError}
            onReset={() => {
                // Reset the state of your app so the error doesn't happen again
                window.location.reload();
            }}
        >
            {children}
        </ReactErrorBoundary>
    );
};

export default ErrorBoundary;
